module.exports = __webpack_public_path__ + "static/rocket-8911a621f7e445c9bcaf0381a8b8a23f.svg";